(ns motorsaif.web.utils
  (:require
   [motorsaif.i18n :as i18n :refer [tr]]
   [promesa.core :as p])
  )

(defn scroll-top []
  (let [ele (js/document.querySelector "#page-wrap")]
    (when ele (.scrollTo ele 0 0))))


(defn copy-fn [to-copy cb]
  (p/let [ret
          (-> (p/promise
               (js/window.navigator.clipboard.writeText to-copy))
              (p/catch (fn [e] :failed)))]
    (if (= ret :failed)
      (cb :failed)
      (cb :success))))
